export const ATTR_TBD_LOAF_TOTAL_DURATION = 'emb.tbd.loaf_total_duration';
export const ATTR_TBD_LOAF_WORK_DURATION = 'emb.tbd.loaf_work_duration';
export const ATTR_TBD_LOAF_STYLE_AND_LAYOUT_DURATION =
  'emb.tbd.loaf_style_and_layout_duration';
export const ATTR_TBD_LOAF_COUNT = 'emb.tbd.loaf_count';
export const ATTR_TBD_LOAF_LONGEST_DURATION = 'emb.tbd.loaf_longest_duration';
export const ATTR_TBD_LOAF_LONGEST_DURATION_EXCLUDING_FIRST =
  'emb.tbd.loaf_longest_duration_excluding_first';

export const BLOCKING_DURATION_GOOD_THRESHOLD = 200;
export const BLOCKING_DURATION_POOR_THRESHOLD = 600;

export const LOAF_EVENT_NAME = 'emb-loaf-report';
export const LOAF_SCRIPTS_EVENT_NAME = 'emb-loaf-scripts';
export const MAX_SCRIPT_URL_LENGTH = 2048;
export const MAX_SCRIPT_ENTRIES = 250;
